/**
 * Library react-query keys. Writes invalidate `all` on purpose — usage
 * counts and package names cross-cut every list.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { LibrarySetKind } from './client/sets-api';

export const libraryKeys = {
  all: ['fo-library'] as const,
  sets: (kind: LibrarySetKind) => ['fo-library', 'sets', kind] as const,
  set: (kind: LibrarySetKind, id: string) =>
    ['fo-library', 'set', kind, id] as const,
  packages: () => ['fo-library', 'packages'] as const,
  package: (id: string) => ['fo-library', 'package', id] as const,
  usage: () => ['fo-library', 'usage'] as const,
  teamContext: () => ['fo-library', 'team-context'] as const,
};
